"use strict";
/*
* Created on 23.04.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Stockout converter.
 *
 * @author ZSr
 */


var StockoutConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(StockoutConverter, _DataObjectConverter_);

  function StockoutConverter() {
    _classCallCheck(this, StockoutConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(StockoutConverter).apply(this, arguments));
  }

  return StockoutConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.StockoutConverter = StockoutConverter;